import { Link } from "react-router-dom";
import { ArrowRight, HardHat, TrendingUp } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SEO } from "../components/SEO";
import { EMAIL } from "../data/site";

const futureTeams = [
  {
    icon: HardHat,
    title: "Engineering",
    text: "Site engineers, project managers and planners who will run our next generation of redevelopment projects.",
  },
  {
    icon: TrendingUp,
    title: "Real Estate Sales & Marketing",
    text: "People who can tell the Parsn story to homebuyers with the same honesty we build with.",
  },
];

export default function Careers() {
  return (
    <main data-testid="careers-page">
      <SEO
        title="Careers — Parsn Group"
        description="Build the next 50 years with Parsn — a growing Mumbai construction and redevelopment organization welcoming engineering and real estate talent."
        path="/careers"
      />
      <section className="bg-white pt-32 sm:pt-44 pb-16 sm:pb-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <p className="overline-label mb-4">Careers</p>
            <h1 className="font-serif text-4xl sm:text-6xl text-ink tracking-tight leading-[1.05] max-w-3xl">
              Come, build the next 50 years <span className="italic text-navy">with us.</span>
            </h1>
            <p className="mt-6 max-w-xl text-base sm:text-lg text-gray-600 leading-relaxed">
              Join the Parsn family, where your work is appreciated and stands for something.
              As a growing organization we are always welcoming new people to our organization,
              and you could be the next one we hire.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-paper border-y border-gray-200 py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal className="max-w-2xl">
            <span className="inline-block text-[11px] font-semibold uppercase tracking-[0.2em] text-navy bg-navy/5 px-4 py-2 mb-8">
              Positions open right now
            </span>
            <h2 className="font-serif text-3xl sm:text-5xl text-ink tracking-tight leading-tight">
              We know who we're hiring <span className="italic text-navy">next.</span>
            </h2>
            <p className="mt-6 text-base sm:text-lg text-gray-600 leading-relaxed">
              As our redevelopment pipeline grows, these are the teams we're building further.
              If either sounds like you, introduce yourself — we keep every genuine note on file.
            </p>
          </Reveal>
          <div className="mt-14 grid md:grid-cols-2 gap-px bg-gray-200 border border-gray-200">
            {futureTeams.map((t, i) => (
              <Reveal key={t.title} delay={i * 0.08} className="bg-white p-8 sm:p-12 h-full">
                <span className="w-12 h-12 bg-navy/5 text-navy flex items-center justify-center" aria-hidden="true">
                  <t.icon size={22} />
                </span>
                <h3 className="mt-6 font-serif text-2xl sm:text-3xl text-ink tracking-tight">{t.title}</h3>
                <p className="mt-4 text-sm sm:text-base text-gray-600 leading-relaxed">{t.text}</p>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-14 flex flex-wrap items-center gap-6">
            <a
              href={`mailto:${EMAIL}?subject=Expression%20of%20interest%20—%20Careers%20at%20Parsn`}
              data-testid="careers-email-button"
              className="inline-flex items-center gap-2 bg-brand text-white text-sm font-semibold px-7 py-4 transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#e0671a]"
            >
              Introduce yourself <ArrowRight size={16} />
            </a>
            <p className="text-sm text-gray-500">
              Write to <span className="font-medium text-ink">{EMAIL}</span> with your CV and the team you're interested in.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal className="flex flex-wrap items-center justify-between gap-8">
            <h2 className="font-serif text-2xl sm:text-4xl text-ink tracking-tight max-w-xl leading-tight">
              Prefer to see what we're building first?
            </h2>
            <Link
              to="/projects"
              data-testid="careers-cta-projects"
              className="inline-flex items-center gap-2 text-sm font-semibold text-navy border-b-2 border-brand pb-1 transition-colors duration-300 hover:text-brand"
            >
              Explore ongoing projects <ArrowRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
